/**
 * 买家端数据字典 API（对接网关 /api/dict/**，blu-system）
 *
 * 与 admin 端 @/api/dict 同源：候选项真源是 sys_dict_data，运营在「字典管理」维护，
 * 前端不再硬编码。调用失败时各调用方回退本地兜底常量。
 */
import { get } from '@/api/request';

/** 字典项 */
export interface DictItem {
  id: string;
  dictType: string;
  dictCode: string;
  dictLabel: string;
  sortOrder?: number;
}

/**
 * 按类型取字典项（后端按 sort_order 升序返回，仅启用项）
 * GET /dict/data/{dictType}
 */
export function listDictDataByType(dictType: string) {
  return get<DictItem[]>(`/dict/data/${dictType}`);
}

/** 国家候选：country 字典的 dictCode 列表；失败返回空数组由调用方兜底 */
export async function listCountries(): Promise<string[]> {
  try {
    const list = await listDictDataByType('country');
    return (list || []).map((d) => d.dictCode).filter((c): c is string => !!c);
  } catch {
    return [];
  }
}
